const serverUrl = 'https://apexqualityhealth-api.ocllis.com/';

export const environment = {
  production: true,
  aiEnabled: false,
  cryptoPassphrase: '42b9b632-b845-4f0c-8c2f-ab886466da8c',
  frontendUrl: 'https://apexqualityhealth.ocllis.com/',
  fusionAuth: {
    apiUrl: 'https://authprovider.ocllis.com/api',
    applicationId: 'bcfe38d1-3d64-4cb5-a899-16a9b905046c',
    apiKey: 'C9kWz5LowlhQBrctfRQh0IqN-D-ZHHTfcvOlYZ35YJE',
    tenantId: 'aa4778e7-dada-dfdd-8b27-eac4c095feff',
  },
  portalBackend: {
    serverUrl,
    apiUrl: `${serverUrl}api`,
  },
  aiAnalysis: {
    enabled: false,
    apiUrl: 'https://portal-analyzer.ocllis.com',
    enabledRoles: ['*']
  },
  aiCommands: {
    enabled: false,
    areas: ['missing-info'],
    apiUrl: 'https://portal-voice-analyzer.ocllis.com'
  },
  sentry: {
    dns: 'https://f8a2e380de96444fa6b36c365cf79eec@o430462.ingest.sentry.io/5440506',
  },
};
